"use client";
import { InitializeRudderStack } from "@/components/InitializeRudderStack";
import { initFirebase } from "@/utils/firebaseConfig";
import { useEffect } from "react";
import { InitializeGoogleTagManager } from "./InitializeGoogleTagManager";
import { getOrCreateDeviceIdClient } from "@/utils/deviceId";
import { getClientPublicIP } from "@/utils/common.helpers";

const FIREBASE_INIT_DELAY_MS = 100;

export const EventsInit = () => {
  useEffect(() => {
    const initDeviceId = async () => {
      try {
        await getOrCreateDeviceIdClient();
      } catch {}
    };
    initDeviceId();

    // Pre-fetch client IP so trackEvent has it cached
    getClientPublicIP().catch(() => {});

    setTimeout(() => {
      initFirebase();
    }, FIREBASE_INIT_DELAY_MS);
  }, []);

  return (
    <>
      <InitializeRudderStack />
      {/* Google Tag Manager is currently disabled. Uncomment InitializeGoogleTagManager component when GTM integration is needed */}
      <InitializeGoogleTagManager />
    </>
  );
};
